import Vue from 'vue';
import VueI18n from 'vue-i18n';
import StoreLocator from './components/StoreLocator.vue';
import { pascalToKebab } from './utils/String';
import i18nConfig from './StoreLocator/i18nConfig';
import './StoreLocator/initVue';

const i18n = new VueI18n(i18nConfig);

Vue.component(StoreLocator.name, StoreLocator);

Array.from(
  document.getElementsByTagName(pascalToKebab(StoreLocator.name))
).forEach((el) => new Vue({ el, i18n }));
